import { useEffect } from "react";

/**
 * Injects a JSON-LD <script> into <head> while the component is mounted.
 * Multiple entries can be added by giving each a unique id.
 */
export default function useJsonLd(id, data) {
  useEffect(() => {
    if (!data) return;
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = `jsonld-${id}`;
    // Remove any existing entry with the same id
    const existing = document.getElementById(el.id);
    if (existing) existing.remove();
    el.text = JSON.stringify(data);
    document.head.appendChild(el);
    return () => {
      el.remove();
    };
  }, [id, data]);
}
